





























































































































































import AfterFetchComponent from "@/components/base/AfterFetchComponent";
import {StoreNamespace} from "@/globals/StoreNamespaceGlobal";
import Component from 'vue-class-component'
import {Prop, Watch} from "vue-property-decorator";
import {Action} from "vuex-class";

@Component({})
export default class PersonalDetailsComponent extends AfterFetchComponent {
  @Prop(Object) personalDetails!: any
  @Prop(Number) memberProcessId!: number

  @Action('hasExistMoreThenOneRequest', StoreNamespace.PROCESSES) hasExistMoreThenOneRequest: any
  @Action('withdrawalAndTransferRows', StoreNamespace.PROCESSES) withdrawalAndTransferRows: any

  private withdrawalAndTransferRow: any;
  private withdrawalAndTransferRowFetch: boolean = false;
  private showWithdrawalAndTransferRowsError: boolean = false;

  @Watch('memberProcessId')
  onMemberProcessIdChanged() {
    if (this.memberProcessId && this.memberProcessId > 0) {
      this.withdrawalAndTransferRowFetch = false;

      this.hasExistMoreThenOneRequest({
        requestorCallback: this,
        pathVariable: this.memberProcessId
      });

      this.withdrawalAndTransferRows({
        requestorCallback: this,
        pathVariable: this.personalDetails.memberIdNum
      });
    }
  }

  private getStatusClass(status: string) {
    switch (status) {
      case 'הבקשה הוגשה':
        return 'request-submit';
      case 'הבקשה בהשהיה' :
        return 'under_examination';
      case 'מאשר שני – מנהל':
      case 'מאשר ראשון – עובד':
        return 'first_approve';
      case 'הבקשה נדחתה':
        return 'rejected'
    }

    return '';
  }

  private onFilterById() {
    const pageSize = this.numberOfRequests <= 10 ? 10 : this.numberOfRequests
    this.$emit('filterById', pageSize)
  }

  private duplicateRequests: boolean = false;
  private numberOfRequests: number = 1;

  onSuccess(data?: any, requestName?: string, message?: string) {
    switch (requestName) {
      case 'hasExistMoreThenOneRequest':
        this.duplicateRequests = data.hasMoreThenOneRequest
        this.numberOfRequests = data.numberOfRequests
        break;
      case 'withdrawalAndTransferRows':
        this.withdrawalAndTransferRow = data
        this.withdrawalAndTransferRowFetch = true;
        break;
    }
  }

  onError(messages: string[], code: number, requestName?: string): void {
    switch (requestName) {
      case 'withdrawalAndTransferRows':
        this.showWithdrawalAndTransferRowsError = true;
        break;
    }
  }

}
